// src/App.js
import { BrowserRouter } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

// Layout
import MainLayout from "./layouts/MainLayout";

// Routes
import AppRoutes from "./routes";

// Providers
import { AppDataProvider } from "./providers/AppDataProvider";

// SEO
import { HelmetProvider } from "react-helmet-async";

import Loading from "./components/Loading";
import Maintenance from "./components/Maintenance";
import useAppData from "./hooks/useAppData";

function AppContent() {
	const { loading, maintenance } = useAppData();

	if (maintenance) return <Maintenance />;
	if (loading) return <Loading />;

	return (
		<>
			<MainLayout>
				<AppRoutes />
			</MainLayout>
		</>
	);
}

function App() {
	return (
		<BrowserRouter>
			<HelmetProvider>
				<AppDataProvider>
					<AppContent />
				</AppDataProvider>
			</HelmetProvider>
		</BrowserRouter>
	);
}

export default App;
